import copyObject from './_copyObject.js';
import keys from './keys.js';

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

export default baseAssign;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseAssign.js
// module id = 668
// module chunks = 0